// 404 page events (analytics sheet → "404 page" row).
import {logAnalyticsEvent} from './analytics';
import {AnalyticsEntryPoint} from './events';

const ENTRY_POINT = AnalyticsEntryPoint.NotFoundPage;

export function trackBackToHomepageClick(failedUrl: string, previousPage?: string) {
  logAnalyticsEvent('back_to_homepage_click', {
    entry_point: ENTRY_POINT,
    failed_url: failedUrl,
    previous_page: previousPage,
  });
}
